import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { TestService } from 'src/app/shared/test.service';
import { Test } from 'src/app/shared/models/test.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-test-add',
    templateUrl: './test-add.component.html',
    styleUrls: ['./test-add.component.css'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatButton, MatInputModule]
})


export class TestAddComponent implements OnInit {
  public testForm: UntypedFormGroup;
  private _test: Test;

  constructor(
    public dialogRef: MatDialogRef<TestAddComponent>,
    public testService: TestService
  ) 
  {

  }

  ngOnInit() {
    this.testForm = new UntypedFormGroup({
      Name: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),      
      Description: new UntypedFormControl('', [ Validators.maxLength(100)]),
      ResultUnit: new UntypedFormControl('', [Validators.required] ),
      ResultType:  new UntypedFormControl('', [Validators.required] ),
      Operator:  new UntypedFormControl('', [Validators.required] ),
      Abbreviation: new UntypedFormControl('', [Validators.maxLength(20)])
    });
  }


  save(){
    
    this.testService.saveTest(this.testForm.value).subscribe(ret => {
      console.log(ret);
      this.dialogRef.close();
    });
  }

  onCancel(){
    this.dialogRef.close();

  }
}
